import { FooterLink } from '@core/shared';
import { useTranslation } from 'react-i18next';

export const Footer = ({ footerLinks }: { footerLinks: FooterLink[] }) => {
    const { t, i18n } = useTranslation();

    return (
        <footer className="flex flex-wrap items-end justify-between gap-6 text-sm sm:text-base 2xl:text-lg font-medium px-4 md:px-8 lg:px-12 pt-3 pb-5 lg:pt-5">
            <div className="flex flex-col md:flex-row gap-x-16 gap-y-4">
                {footerLinks.map((link, index) => {
                    let url = link.url;
                    if (link.urls) {
                        if (i18n.language in link.urls) {
                            url = link.urls[i18n.language];
                        }
                    }
                    if (!url) return <></>;
                    return (
                        <a key={`footer-link-${index}`} href={url} target="_blank" rel="noreferrer">
                            {t(link.title)}
                            <span className="sr-only">{t('Generic.Link.OpensInNewTab')}</span>
                        </a>
                    );
                })}
            </div>
            <div className="whitespace-nowrap">
                &copy;{new Date().getFullYear()}{' '}
                <a href="https://www.onlinewebinar.com/" target="_blank" rel="noopener noreferrer">
                    OnlineWebinar
                </a>
            </div>
        </footer>
    );
};
